import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, Clock } from "lucide-react";
import { fetchSub } from "@/lib/subLock";

export const SubscriptionBanner = () => {
  const [s, setS] = useState(null);
  useEffect(() => { fetchSub().then(setS); }, []);
  if (!s) return null;
  const soon = s.entitled && ["trial", "active"].includes(s.status) && s.days_left != null && s.days_left <= 7;
  if (s.entitled && !soon) return null;
  const blocked = !s.entitled;
  const msg = blocked
    ? s.status === "pending_approval"
      ? "İşletmeniz yönetici onayı bekliyor. Onaydan sonra ücretsiz deneme süreniz başlar."
      : s.status === "suspended"
        ? `Hesabınız yönetici tarafından askıya alındı${s.suspended_reason ? `: ${s.suspended_reason}` : ""}. Yeni teklif veremez, ilan açamaz ve iş alamazsınız.`
        : s.trial_review === "pending"
          ? "Ücretsiz deneme hakkınız yönetici incelemesinde. Bu sürede abonelik satın alarak hemen devam edebilirsiniz."
          : "Aboneliğinizin süresi doldu. Yeni teklif veremez, ilan açamaz ve yeni iş alamazsınız. Devam eden işlerinizi tamamlayabilir, geçmiş kayıtlarınızı görebilirsiniz."
    : `${s.status === "trial" ? "Ücretsiz deneme sürenizin" : "Aboneliğinizin"} bitmesine ${s.days_left} gün kaldı.`;
  return (
    <div className={`rounded-2xl p-4 mb-4 flex flex-col sm:flex-row sm:items-center gap-3 ${blocked ? "bg-destructive/10 border border-destructive/40" : "bg-amber-500/10 border border-amber-500/40"}`} data-testid="sub-banner">
      {blocked ? <AlertTriangle className="w-6 h-6 text-destructive shrink-0" /> : <Clock className="w-6 h-6 text-amber-600 shrink-0" />}
      <div className="flex-1 text-sm" data-testid="sub-banner-text"><b>{s.status_label}.</b> {msg}</div>
      {s.status !== "pending_approval" && s.status !== "suspended" && (
        <Link to="/panel?tab=membership" className="shrink-0 rounded-full bg-[hsl(var(--brand-black))] text-white px-4 py-2 text-sm font-bold hover:brightness-125" data-testid="sub-banner-cta">Abonelik satın al</Link>
      )}
    </div>
  );
};
